import { Web3Exception } from '@injectivelabs/exceptions';
/**
 * Preparing and broadcasting
 * Ethereum transactions
 */
export class Web3Broadcaster {
    walletStrategy;
    evmChainId;
    constructor({ walletStrategy, evmChainId, }) {
        this.evmChainId = evmChainId;
        this.walletStrategy = walletStrategy;
    }
    async sendTransaction(args) {
        const { evmChainId, walletStrategy } = this;
        try {
            const chainId = args.evmChainId || evmChainId;
            const txHash = await walletStrategy.sendEvmTransaction(args.tx, {
                evmChainId: chainId,
                address: args.address,
            });
            await walletStrategy.getEvmTransactionReceipt(txHash, chainId);
            return txHash;
        }
        catch (e) {
            throw new Web3Exception(new Error(e.message));
        }
    }
}
